import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter)

const tickets: RouteConfig = {
  path: '/tickets',
  components: { 
    default: () => import('../views/ticket-dashboard.vue'),
    title: () => import('../views/ticket-app-title-bar.vue')
  },
};

const ticketDetail: RouteConfig = {
  path: '/tickets/:id',
  components: {
    default: () => import('../views/ticket-detail.vue'),
    title: () => import('../views/ticket-app-title-bar.vue')
  },
  props: {
    default: true
  }
};

const ticketCreate: RouteConfig = {
  path: '/tickets/:id/template',
  components: {
    default: () => import('../views/ticket-create.vue'),
    title: () => import('../views/ticket-app-title-bar.vue')
  },
  props: {
    default: true
  }
};
const authed: RouteConfig = {
  path: '/authed',
  components: { 
    default: () => import('../views/ticket-dashboard.vue'), 
    title: () => import('../views/ticket-app-title-bar.vue') 
  },
  meta: { auth: true }
};
const initial: RouteConfig = { path: '/', redirect: '/tickets' };

// Make sure the ticketDetail is last because it will match any tickets/
const routes = [
  /* other routes go here */
  tickets, ticketCreate, ticketDetail, authed, initial
];

const router = new VueRouter({ mode: 'history', base: '/', routes });

export default router
